export default __webpack_public_path__ + "static/media/nepal2015B.4b2e4edb.jpg";